module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "d7e84"
    }
  }, [_c('h1', {
    staticClass: "chapno"
  }, [_c('a', {
    attrs: {
      "id": "c1"
    }
  }, [_c('h2', {
    staticClass: "chapttl",
    attrs: {
      "id": "d7e85"
    }
  }, [_vm._v("Premonitions of the "), _c('i', [_vm._v("Titanic's")]), _vm._v(" Doom")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e90"
    }
  }, [_c('span', {
    staticClass: "capl"
  }, [_vm._v("O")]), _vm._v("n 14 April 1912 the RMS "), _c('i', [_vm._v("Titanic")]), _vm._v(", then the world's largest passenger liner, struck an iceberg during her maiden voyage. Eventually disappearing into the near-freezing depths of the North Atlantic, she claimed the lives of more than 1,500 passengers and crew. The sheer enormity of this sudden and unexpected tragedy has resulted in the White Star Line's "), _c('i', [_vm._v("Titanic")]), _vm._v(" being considered the gauge by which all subsequent maritime disasters are measured.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e100"
    }
  }, [_vm._v("At the time of her loss, the "), _c('i', [_vm._v("Titanic")]), _vm._v(" carried a total of 1,320 passengers, (337 first class, 271 second class and 712 third class), together with a crew of just over 900. Should various newspaper reports be accepted as fact, then it is clear that a great many of these passengers and crew were convinced that the vessel was doomed even before she left her home port of Southampton.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e105"
    }
  }, [_vm._v("Strange as it may seem, many of those boarding the "), _c('i', [_vm._v("Titanic")]), _vm._v(" had received a forwarning of the coming disaster. The majority seem to have ignored these warnings, accepting the popular opinion that this latest technological wonder was unsinkable. Others did take some form of action. In some cases this took the form of a warning to friends and relatives that they might never see them again while others simply put their affairs in order before leaving. Additionally, of course, a number of those who were subject to these premonitions changed their minds about boarding the ship. In fact, it must be counted as one of the reasons why the "), _c('i', [_vm._v("Titanic")]), _vm._v(", on that much publicised voyage, sailed partly empty. In point of fact, she had accommodation for a further eight hundred or more passengers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e113"
    }
  }, [_vm._v("This belief in the ship being doomed, even before she sailed, must rate among the most peculiar episodes of maritime history. After all, she was one of the largest, most comfortable and technically efficient liners ever to attempt a crossing of the Atlantic. Having a displacement of 60,000 tons, she was nearly a sixth of a mile in length (882.5 ft) while her height was equal to that of an eleven storey building. As for her engines, these were capable of developing power in excess of 50,000 hp and sufficient to give the vessel a maximum speed of 25 knots. Considered the safest vessel afloat, her security was ensured by a double bottom and sixteen watertight compartments. Yet, despite this wealth of sophistication, hundreds of ordinary people were convinced that the "), _c('i', [_vm._v("Titanic")]), _vm._v(" would never reach America!")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e118"
    }
  }, [_vm._v("As for proof of these psychic forewarnings it is only necessary to turn to the pages of various contemporary newspapers. In reporting the tragedy, many of them carried interviews with those who had, in some way, come into contact with the "), _c('i', [_vm._v("Titanic")]), _vm._v(". Without prompting, and unknown to each other, a surprisingly large number mention inexplicable fears that led them to believe that the vessel was doomed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e123"
    }
  }, [_vm._v("It is the local papers in the ship's home port of Southampton that provide the largest concentration of such reports. Because many of the crew were natives of this particular town, local journalists were able to visit a number of bereaved families. In addition, they also came upon a number of individuals who were due to have joined the "), _c('i', [_vm._v("Titanic")]), _vm._v(" but chose not to do so. Two items that appeared in the "), _c('i', [_vm._v("Southampton Times")]), _vm._v(" are of particular interest. The first relates to an interview carried out on the doorstep of a small terraced house in Andersons Road:")]), _vm._v(" "), _c('div', {
    staticClass: "extvc",
    attrs: {
      "id": "d7e131"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e132"
    }
  }, [_c('b', [_vm._v("Mrs Burrows was to be seen there and she said, ‘My son Harry goes to sea, and he had stayed home for a month in the expectation of getting engaged on the "), _c('i', [_vm._v("Titanic")]), _vm._v(". He went down to the docks to sign on, but at the last moment changed his mind and came away, for which we are very thankful. I can't explain why he changed his mind, some sort of feeling came over him, he told me.’ ["), _c('i', [_vm._v("Southampton Times and Hampshire Express")]), _vm._v(", 20 April 1912]")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e141"
    }
  }, [_vm._v("The second of two reports from the "), _c('i', [_vm._v("Southampton Times")]), _vm._v(" proves even more intriguing:")]), _vm._v(" "), _c('div', {
    staticClass: "extvc",
    attrs: {
      "id": "d7e146"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e147"
    }
  }, [_c('b', [_vm._v("Inquiries in Chantry Road led to the discovery that in one house there resided four men, all of whom signed to sail on the "), _c('i', [_vm._v("Titanic")]), _vm._v(", but arrived at the quay side too late to get on board. They were the three brothers Slade and another named Penney. They left home together to go to the ship, but when they arrived, the gangway had been removed, and they were told they could go home again. Mrs Slade was seen by our representative, and her first words were, ‘What a good job they missed their ship! I have thanked God for it ever since.’ ‘How did they miss the boat?’ she was asked. ‘I can't tell you exactly, but they left home in good time. Somehow or other my boys did not seem very keen on going in the ship. You may not believe in dreams, but I am telling you the truth when I say that one of my boys had a dream about the boat the night before sailing day, and he afterwards said that he had a dread of her. I know they were not very keen on going, but nevertheless they went down. The engineer called to them to get on board, but for some reason or other they didn't go.’["), _c('i', [_vm._v("Southampton Times and Hampshire Express")]), _vm._v(", 20 April 1912]")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e156"
    }
  }, [_vm._v("A second Southampton newspaper, the "), _c('i', [_vm._v("Hampshire Independent")]), _vm._v(", also carried a number of similar reports. One of these concerned members of the Ward family:")]), _vm._v(" "), _c('div', {
    staticClass: "extvc",
    attrs: {
      "id": "d7e162"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e163"
    }
  }, [_c('b', [_vm._v("‘Please I've got a cable from my dad. He's saved’. These were the words of little Jackie Ward, who rushed into our office yesterday morning, his face beaming with delight. He told us that his father was making his first trip as a steward in the employ of the White Star Company, having previously sailed on American boats. He is an Australian, as is also Mrs. Ward, who needless to say, was overjoyed at the news of her husband's safety. This is the sixth time that Mr. Ward has been wrecked. On one occasion he was picked up after being two days in an open boat under tropical skies. Mrs. Ward waited for hours outside the White Star offices on Monday and Tuesday, but gave up all hope on Wednesday, and ‘broke down’ as Jackie said. Her hopes were revived when she received a letter from her husband's mother, 14,000 miles away in Australia, saying that her son had gone through so many perils that she had no fears for his safety. Jackie, too, was full of hope and regularly prayed that his father would be rescued. A remarkable thing was that he told his father not to go ‘as the ship was going to roll over’. Since the disaster, the little lad told us, he had dreamed three times in succession that he and his father and mother went to the ‘pictures' which fact convinced him that no harm would come to his father.’ ["), _c('i', [_vm._v("Hampshire Independent")]), _vm._v(", 20 April 1912]")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e169"
    }
  }, [_vm._v("In addition, the "), _c('i', [_vm._v("Hampshire Independent")]), _vm._v(" carried two further reports relating to those who may well have had premonitions of the forthcoming tragedy. Indeed, one of them went so far as to desert the ship at Queenstown in southern Ireland, (better known to-day as Cobh), the "), _c('i', [_vm._v("Titanic")]), _vm._v("'s last port of call before heading out into the Atlantic:")]), _vm._v(" "), _c('div', {
    staticClass: "extvc",
    attrs: {
      "id": "d7e177"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e178"
    }
  }, [_c('b', [_vm._v("One man who sailed from Southampton with grave, but undefinable misgivings, left the boat at Queenstown. Another, a steward who lived in the Shirley district told his wife before his departure, that he wished he had never ‘signed on’. ["), _c('i', [_vm._v("Hampshire Independent")]), _vm._v(", 20 April 1912]")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e184"
    }
  }, [_vm._v("A second city in the United Kingdom that was closely connected with the "), _c('i', [_vm._v("Titanic")]), _vm._v(" was Belfast. It was here, at the Harland & Wolff shipyard, that she was launched on 31 May 1911. Over the following months the thousands of workers involved in her construction, together with their families and friends, would have taken a close interest in the vessel's progress. The resulting tragedy, which came as a severe shock to the Belfast community, was treated in great detail by each of the local newspapers. Again, there were numerous references to those who appear to have received some form of psychic forewarning. The "), _c('i', [_vm._v("Belfast Evening Telegraph")]), _vm._v(" provides the first of two examples:")]), _vm._v(" "), _c('div', {
    staticClass: "extvc",
    attrs: {
      "id": "d7e192"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e193"
    }
  }, [_c('b', [_vm._v("Amongst the many weird stories of the Titanic, perhaps the most remarkable is that of the restaurant staff. No fewer than ten cousins of the manager, Mr. L. Gatti — who is reported missing — were engaged in preparing food for the ship. Their fate is unknown, but it was foreseen by the wife of Mr. Gatti, whose home was at Southampton.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e196"
    }
  }, [_c('b', [_vm._v("The shadow of danger disturbed her sleep on the night the ship went down. She had a strange presentiment of danger and could not rest.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e199"
    }
  }, [_c('b', [_vm._v("In the morning her presentiment had such an effect on her that, on Monday, she travelled to London and stayed with her sister.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e202"
    }
  }, [_c('b', [_vm._v("But her restlessness pursued her until the news of the disaster arrived. ["), _c('i', [_vm._v("Belfast Evening Telegraph")]), _vm._v(", 18 April 1912]")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e208"
    }
  }, [_vm._v("Some weeks after that particular report, the "), _c('i', [_vm._v("Belfast Newsletter")]), _vm._v(" carried this story which is headed as ‘Wexford Man's Dream’:")]), _vm._v(" "), _c('div', {
    staticClass: "extvc",
    attrs: {
      "id": "d7e213"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e214"
    }
  }, [_c('b', [_vm._v("Mr Patrick O'Keeffe, of Spring Garden Alley, Waterford, who was saved from the Titanic, has written a letter to his father in which he states that the night before he sailed from Queenstown he dreamt the Titanic was going down. ["), _c('i', [_vm._v("Belfast Newsletter")]), _vm._v(", 7 May 1912]")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e220"
    }
  }, [_vm._v("However, such reports of psychic forewarning were not simply restricted to those towns in some way specially connected with the "), _c('i', [_vm._v("Titanic")]), _vm._v(". Consider this range of examples drawn from a number of different regional papers published in the weeks immediately following the loss of the "), _c('i', [_vm._v("Titanic")]), _vm._v(". The "), _c('i', [_vm._v("New York Tribune")]), _vm._v(" carried this particular story collected from Hemingford, Nebraska:")]), _vm._v(" "), _c('div', {
    staticClass: "extvc",
    attrs: {
      "id": "d7e231"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e232"
    }
  }, [_c('b', [_vm._v("Because she dreamed she saw the Titanic sinking, Mrs. B. O. Shepherd of Hemingford, sent word to her husband in England to cancel his reservation on that steamer and to return on another boat. The fact that he did so probably saved his life.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e235"
    }
  }, [_c('b', [_vm._v("The dream took place two months ago, Mrs. Shepherd first wrote to her husband asking him not to take the Titanic home. She then sent a cable message to him to the same effect. Although he had already taken passage on that steamer, Shepherd transferred to another White Star boat. ["), _c('i', [_vm._v("New York Tribune")]), _vm._v(", 22 April, 1912]")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e241"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("Washington Post")]), _vm._v(" gleaned this story from New York:")]), _vm._v(" "), _c('div', {
    staticClass: "extvc",
    attrs: {
      "id": "d7e246"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e247"
    }
  }, [_c('b', [_vm._v("The fallacy and infallibility of fortune tellers is not always to be relied on said one of the officers of the steamship George Washington, when a matter of superstitions, vague fears and forebodings was brought up.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e250"
    }
  }, [_c('b', [_vm._v("I have been going to sea for a great many years, and in the natural course of things a lot of the tradition of the sea has been rubbed in. There is one incident in particular that was strange. Last year in Bremerhaven my wife and I with our two daughters went to the fair — a cattle fair it was — and the outlying grounds were filled with a gypsy camp. For the fun of the thing we decided to have the future read. Oh, so old a crone. She was 80 if a day, and as her dim eyes peered into the hollow of my palm I could not help laughing.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e253"
    }
  }, [_c('b', [_vm._v("Shaking with palsy, she looked up, and there was a peculiar expression in her wavering stare.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e256"
    }
  }, [_c('b', [_vm._v("‘You may laugh,’ she quavered. ‘They always do laugh, but on the sea lies your work, and next year the greatest ship in the world will sink — sink — sink!’")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e259"
    }
  }, [_c('b', [_vm._v("And still I laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e262"
    }
  }, [_c('b', [_vm._v("She thrust my hand aside and began to cry. ‘I have told you too much! Sadness — death — sinking — sinking!’")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e265"
    }
  }, [_c('b', [_vm._v("My wife and I left the crazy quilt tent — still laughing.’ ["), _c('i', [_vm._v("Washington Post")]), _vm._v(", 21 April 1912]")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e272"
    }
  }, [_vm._v("Several newspapers published in North America also carried references to reported fears of Major Archibald Butt, a military aide to President Taft who was among the 1,500 who died on that fateful night in April:")]), _vm._v(" "), _c('div', {
    staticClass: "extvc",
    attrs: {
      "id": "d7e274"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e275"
    }
  }, [_c('b', [_vm._v("A mysterious warning that he would meet death on his trip abroad came to Major Archibald Butt before he left Washington six weeks ago when the major determined on a European trip to regain his health. A premonition that he might not return alive caused him to make his will. He called in a lawyer and closed his affairs. ["), _c('i', [_vm._v("Montreal Star")]), _vm._v(", 17 April 1912]")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e281"
    }
  }, [_vm._v("Returning to the British Isles, this intriguing report came from the tiny Irish village of Athenry:")]), _vm._v(" "), _c('div', {
    staticClass: "extvc",
    attrs: {
      "id": "d7e283"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e284"
    }
  }, [_c('b', [_vm._v("A strange report of a mother's dream in connection with the Titanic disaster comes from Athenry, where a young farmer had determined to emigrate, and had, in fact, made arrangements for the booking of his passage on the ill-fated Titanic. His mother, however, dreamed three nights in succession that the boat upon which her son was to travel had gone down and in her vision she states she saw the vessel sinking in mid-ocean with all on board. So deep an impression did the dream make upon her that she pleaded with her son to remain at home and ultimately succeeded in keeping him. Four days after the liner on which he was to sail had left Queenstown, her remarkable dream had been in part, at least, fulfilled. ["), _c('i', [_vm._v("The Cork Examiner")]), _vm._v(", 2 May 1912]")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e290"
    }
  }, [_vm._v("Finally, in case there is a temptation to believe that each and every cancelled passage came about as the result of a premonition, it is useful to refer to this more down-to-earth offering from Margate in Kent. It concerns Norman Craig, the Member of Parliament for that particular constituency:")]), _vm._v(" "), _c('div', {
    staticClass: "extvc",
    attrs: {
      "id": "d7e292"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e293"
    }
  }, [_c('b', [_vm._v("A wonderful piece of luck appears to have favoured the MP for Thanet. Mr Craig had indeed booked his passage and until the day before Good Friday had intended to sail for New York in the newest leviathan. Intuition without any presentiment suggested he would be better advised to remain at home during the Home Rule debate in the House of Commons and the passage was cancelled. ["), _c('i', [_vm._v("Isle of Thanet Gazette")]), _vm._v(", 20 April 1912]")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e299"
    }
  }, [_vm._v("Another of those lost in this great tragedy was a certain W. T. Stead, a well known journalist who edited the periodical "), _c('i', [_vm._v("Review of Reviews")]), _vm._v(", and who had a particular interest in spiritualism. Indeed, Stead himself claimed the ability to communicate with the ‘other world’ through the use of automatic writing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e304"
    }
  }, [_vm._v("As part of his interest in spiritualism, Stead had made a point of visiting a large number of mediums, palm readers and others who claimed the ability to view the future. During the course of his visits, many of these clairvoyants had made predictions about Stead's future, several of them specifically referring to how his life would eventually end. Admittedly, several of their predictions were contradictory, but a number of them (perhaps the majority) were extremely close to the truth. Indeed, if Stead had but realised it, he was in fact warned of the impending disaster.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e306"
    }
  }, [_vm._v("One of the earliest of these predictions was made in January 1892 when a palm reader clearly indicated that he would die during the year 1912.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e308"
    }
  }, [_vm._v("A previous clairvoyant had, so it should be pointed out, indicated that Stead's death would come in 1924. However, even given this conflict of information, the fact that one of these two clairvoyants should accurately predict the year of his demise is, in itself, quite remarkable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e310"
    }
  }, [_vm._v("Of the various clairvoyants that Stead chose to visit, there is a remarkable similarity in at least one of their predictions. On numerous occasions, Stead was informed that he would be threatened by water, with one of them going as far as to associate this with a huge passenger liner. The most accurate of these predictions came in May 1911. While attending a seance held in Detroit, the spirit of a native American informed him that he would die after one further crossing of the Atlantic. This is exactly what happened!")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e313"
    }
  }, [_vm._v("Stead, for his own part, seemed remarkably unaffected by these warnings. Certainly he does not appear to have had any qualms upon boarding the "), _c('i', [_vm._v("Titanic")]), _vm._v(". During the first day of his voyage he penned a letter, subsequently posted from Queenstown. Written to a close friend, it declared the ship to be ‘as firm as a rock’ and added that he felt able to work better on board ‘for there are no telephones to worry me, and no callers.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e318"
    }
  }, [_vm._v("Another interesting facet of W. T. Stead's connection with the "), _c('i', [_vm._v("Titanic")]), _vm._v(" are the themes of two stories he wrote towards the end of the nineteenth century. The first of these, published in "), _c('i', [_vm._v("The Pall Mall Gazette")]), _vm._v(" in 1886, concerns the sinking of an ocean liner and describes an excessive number of lives being lost because the vessel had an inadequate number of lifeboats. That Stead and many others were to lose their lives was directly related to the same problem. The "), _c('i', [_vm._v("Titanic")]), _vm._v(" had only twenty lifeboats, sufficient for only about half the number of passengers carried by the vessel on that voyage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e329"
    }
  }, [_vm._v("The second of Stead's two stories was entitled "), _c('i', [_vm._v("From the Old World to the New")]), _vm._v(", published in the Christmas 1892 edition of the "), _c('i', [_vm._v("Review of Reviews")]), _vm._v(". This included an account of a passenger liner coming to the rescue of a few survivors from another vessel that had struck an iceberg. Although a work of fiction this story did contain some factual background and remarkably, the rescuing liner, apart from being owned by the White Star Company, was captained by no less a person than Edward Smith. This same Captain Smith commanded the "), _c('i', [_vm._v("Titanic")]), _vm._v(" on her maiden voyage going, down with his ship.")])])])]), _c('a', {
    attrs: {
      "id": "c1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7b5753c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HARP_9780715337851_epub_c1.vue
// module id = 66
// module chunks = 0